import axios from '../utils/index';
import { Pat } from '@/typings/request';
const settingsApi = {
    async uploadFile(data: Pat) {
        return axios.post(`/upload/file`, data);
    },
    async versionAdd(data: Pat) {
        return axios.post(`/version`, data);
    },
    async versionList(params: Pat) {
        return axios.get(`/version`, { params });
    },

    async getBrokerurl() {
        return axios.get(`/v1/admin/sys/broker-url`);
    },
    async editBrokerurl(data: Pat) {
        return axios.put(`/v1/admin/sys/broker-url`, data);
    },
    async getInsuranceurl() {
        return axios.get(`/v1/admin/sys/insurance-url`);
    },
    async editInsuranceurl(data: Pat) {
        return axios.put(`/v1/admin/sys/insurance-url`, data);
    },
};
export default settingsApi;
